module.exports = __webpack_public_path__ + "img/muchBelowNormal.370c3707.svg";